import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ButtonAction } from '../../component-button-action';
import { Play } from '../../component-icons';
import { forwardRef } from 'react';
export const EditorialTeaserMediaAction = forwardRef((props, ref) => {
    return (_jsx(ButtonAction, { variant: "prominent", size: "md", icon: Play, ...props, ref: ref }));
});
EditorialTeaserMediaAction.displayName = 'EditorialTeaserMediaAction';
